// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mainnet as _mainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1
 * Chain Name: Ethereum
 * Default Block Explorer: https://etherscan.io
 * Default RPC URL: https://cloudflare-eth.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mainnet = createCommon({
	..._mainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
